import { type TypedUseSelectorHook, useDispatch, useSelector } from 'react-redux';

import { type DefaultReducersReduxState } from '../../reducers/useSbSelector.ts';

type PdpReduxState = DefaultReducersReduxState; // & PdpReducersState, reducers still in jsx update to ReturnType<typeof store.getState>
type PdpAppDispatch = $TSFixMe; // reducers still in jsx update to typeof store.dispatch;

export const useAppDispatch: () => PdpAppDispatch = useDispatch;
export const useAppSelector: TypedUseSelectorHook<PdpReduxState> = useSelector;
